import workflowApi from '../api'
import {TaskEditorModal} from '../task/WorkflowTaskEditor'
import {WorkflowTaskStore} from '../task/WorkflowTaskStore'
import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Popover, PopoverBody, PopoverHeader} from 'reactstrap'
import ReactDOM from 'react-dom'
import sessionStore from '../../../services/session/SessionStore'
import {observer} from 'mobx-react'

export const EntityTaskTypeButton = observer(class EntityTaskTypeButton extends Component {
  static propTypes = {
    // newTask: PropTypes.func.isRequired,
    entityId: PropTypes.string.isRequired,
    entityTaskTypes: PropTypes.array.isRequired,
    entityData: PropTypes.any,
    trigger: PropTypes.any.isRequired,
    placement: PropTypes.string.isRequired
  }

  static defaultProps = {
    placement: "top"
  }

  state = {
    popoverOpen: false,
    tasksLoaded: false,
    tasksLoading: false,
    tasks: [],
    store: null,
    step: 0,
    entityTaskType: null,
    buttonRef: null
  }

  togglePopover = () => {
    const willBeOpen = !this.state.popoverOpen;
    // buggy "legacy" event triggers a toggle when you hit the close button from event propagation
    const wasJustClosed = this.state.popoverClosed && new Date().valueOf() - this.state.popoverClosed < 1000;
    if (wasJustClosed && willBeOpen) {
      return;
    }
    this.setState({popoverOpen: willBeOpen})
    if (willBeOpen && !(this.state.tasksLoaded || this.state.tasksLoading)) {
      this.setState({tasksLoading: true})
      workflowApi.loadTasksByEntityIds(this.props.entityId)
        .then(result => {
          this.setState({
            tasks: result.tasks,
            tasksLoaded: true,
            tasksLoading: false
          })
        })
    }
  };

  closePopover = (e) => {
    this.setState({ popoverOpen: false, popoverClosed: new Date().valueOf(), step: 0 })
  };

  onSelected = (e) => {
    const taskId = e.target.value
    const task = this.state.tasks.find(x => x._id === taskId)
    this.setState({
      popoverOpen: false,
      store: new WorkflowTaskStore({ task, taskData: this.props.entityData })
    })
  };

  onSelectedTaskType = (e) => {
    this.setState({ entityTaskType:  this.props.entityTaskTypes[e.target.value] });
  }

  onCreate = () => {
    // TODO - this state variable is really non-descriptive. Just means that we're selecting a task type.
    // Skip selection (step 1) if there's only one task type option
    if (this.state.step === 1 || this.props.entityTaskTypes.length === 1) {
      const selectedType = this.props.entityTaskTypes.length === 1 ? this.props.entityTaskTypes[0] : this.state.entityTaskType
      this.setState({
        popoverOpen: false,
        store: new WorkflowTaskStore({ taskTemplate: this.props.newTask(selectedType.name, selectedType.value), taskData: this.props.entityData })
      })
    } else {
      this.setState({ step: 1 })
    }
  };

  unload = () => {
    this.setState({
      store: null,
      tasks: [], tasksLoaded: false, tasksLoading: false, modal: null, popoverOpen: false, step: 0, entityTaskType: undefined
    })
  };

  renderSelect = (tasksLoaded, tasks) => {
    const {step, entityTaskType} = this.state;
    const {entityTaskTypes} = this.props;
    switch(step){
      case 1:
        return (
          <span className="review-task-selection">
            <label>Select a task type</label>
            <select style={{width: '100%'}} value={entityTaskType ? entityTaskTypes.indexOf(this.state.entityTaskType) : ""} onChange={this.onSelectedTaskType}>
              <option key="placeholderTaskTypes" value="" disabled>-- Select a Task Type --</option>
              {
                entityTaskTypes.map((ett, i) => <option key={ett.value} value={i}>{ett.name}</option>)
              }
            </select>
          </span>
        );
      case 0:
      default:
        if(tasksLoaded && !tasks.length) {
          return "No Tasks";
        }else if(tasksLoaded) {
          return (
            <span className="review-task-selection">
              <select style={{width: '100%'}} defaultValue="" onChange={this.onSelected}>
                <option key="placeholderTasks" value="" disabled>-- Select a Task --</option>
                {
                  tasks.map(task =>
                    <option key={task._id}
                            value={task._id}>{task.content.status === "Complete" && '✔'} {task.content.taskName}</option>
                  )
                }
              </select>
            </span>
          );
        }
    }
  }

  render() {
    const {tasks, tasksLoaded, popoverOpen, store, buttonRef, step} = this.state

    if (
      !sessionStore.sessionLoaded ||
      sessionStore.user.permissions.indexOf('ShowWorkflow') < 0 ||
      sessionStore.brandConfig.restrictions.hideWorkflow2
    ) {
      return null;
    }

    const renderPopover = () => {
      if (!buttonRef) {
        return <Fragment/>
      }
      const {width, height} = step === 0 ? { width: 228, height: 140 } : { width: 258, height: 175 };

      return <Popover
        target={buttonRef}
        isOpen={popoverOpen && !store} // !store - force popover closed when the modal is open.
        toggle={this.togglePopover}
        trigger={"click legacy"}
        id="popover-positioned-top"
        placement="top"
        style={{width: `${width}px`, minWidth: `${width}px`}}
      >
        <PopoverHeader>
          Tasks
        </PopoverHeader>
        <PopoverBody>
          <div className="task-editor">
            <div>
              {
                !tasksLoaded && <div><span className="fas fa-spinner fa-spin"></span></div>
              }
              {
                this.renderSelect(tasksLoaded, tasks)
              }
            </div>
            <br/>
            <div className="d-flex justify-content-end">
              <div>
                <button className="btn btn-outline-secondary" onClick={this.closePopover}>Close</button>
                <button className="btn btn-secondary control-spacer-left" onClick={this.onCreate}>{step === 0 ? "Add Task" : "Create Task"}</button>
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    }

    return <span className="position-relative" id={this.uid}>
      <span ref={el => el !== buttonRef && this.setState({ buttonRef: el}) }>{this.props.trigger}</span>
      <Portal createElement={() => {
        return document.createElement('div')
      }}>{renderPopover()}</Portal>
      {store && <TaskEditorModal store={store} onClose={this.unload}/>}
    </span>
  }
});

/**
 * portal for modal/popover to append to body
 * https://reactjs.org/docs/portals.html
 */
class Portal extends React.Component {
  static propTypes = {
    createElement: PropTypes.func
  }
  constructor(props) {
    super(props);


    this.el = this.props.createElement();
    if (!this.el) {
      throw new Exception("failed to create portal element")
    }
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }


}
